<div class="ca-toggle">
    <mat-slide-toggle
        [hideIcon]="hideIcon()"
        [checked]="value()"
        (change)="valueChanged.emit($event.checked); hideIcon.set(!$event.checked)"
    ></mat-slide-toggle>
    <ng-content></ng-content>
</div>
